module.exports = __webpack_public_path__ + "static/img/icon1.1d21860e.png";